var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "time-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg time",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,2.91A13.09,13.09,0,1,0,29.09,16,13,13,0,0,0,16,2.91ZM0,16A16,16,0,1,1,16,32,16,16,0,0,1,0,16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5.82a1.37,1.37,0,0,1,1.45,1.45v7.86L22.4,17.6A1.28,1.28,0,0,1,23,19.49a1.28,1.28,0,0,1-1.89.58l-5.82-2.91A1.15,1.15,0,0,1,14.55,16V7.27A1.37,1.37,0,0,1,16,5.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.92dcce84e40bff3dca388cee1fd358b8.svg";
export { ForwardRef as ReactComponent };